let ctx = null;

function ac() {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state !== "running") ctx.resume().catch(() => {});
  return ctx;
}

let silentEl = null;
function silentWavUrl() {
  const n = 800, buf = new ArrayBuffer(44 + n * 2), v = new DataView(buf);
  const w = (o, str) => [...str].forEach((c, i) => v.setUint8(o + i, c.charCodeAt(0)));
  w(0, "RIFF"); v.setUint32(4, 36 + n * 2, true); w(8, "WAVE"); w(12, "fmt ");
  v.setUint32(16, 16, true); v.setUint16(20, 1, true); v.setUint16(22, 1, true);
  v.setUint32(24, 8000, true); v.setUint32(28, 16000, true); v.setUint16(32, 2, true); v.setUint16(34, 16, true);
  w(36, "data"); v.setUint32(40, n * 2, true);
  return URL.createObjectURL(new Blob([buf], { type: "audio/wav" }));
}

// iOS: must create/resume the context and play something inside a user gesture.
// Also switch the audio session to "playback" so the ringer/silent switch doesn't mute game sounds.
function unlockFromGesture() {
  try {
    if (navigator.audioSession && navigator.audioSession.type !== "playback") navigator.audioSession.type = "playback";
    if (!silentEl) {
      silentEl = new Audio(silentWavUrl());
      silentEl.setAttribute("playsinline", "");
      silentEl.setAttribute("x-webkit-airplay", "deny");
      silentEl.preload = "auto";
      silentEl.loop = false;
    }
    if (silentEl.paused) silentEl.play().catch(() => {});
    const c = ac();
    const src = c.createBufferSource();
    src.buffer = c.createBuffer(1, 1, 22050);
    src.connect(c.destination);
    src.start(0);
  } catch (e) { /* audio unsupported */ }
}

if (typeof window !== "undefined") {
  ["touchend", "pointerdown", "click", "keydown"].forEach((ev) =>
    window.addEventListener(ev, () => { if (!ctx || ctx.state !== "running") unlockFromGesture(); }, { capture: true, passive: true }),
  );
}

function noiseBuffer(c, dur) {
  const buf = c.createBuffer(1, Math.floor(c.sampleRate * dur), c.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / d.length) ** 3;
  return buf;
}

function click(t, freq, gain, dur = 0.05) {
  const c = ac();
  const src = c.createBufferSource();
  src.buffer = noiseBuffer(c, dur);
  const bp = c.createBiquadFilter();
  bp.type = "bandpass"; bp.frequency.value = freq; bp.Q.value = 6;
  const g = c.createGain();
  g.gain.value = gain;
  src.connect(bp).connect(g).connect(c.destination);
  src.start(c.currentTime + t);
}

function tone(t, freq, dur, gain, type = "sine", endFreq) {
  const c = ac();
  const o = c.createOscillator();
  const g = c.createGain();
  const s = c.currentTime + t;
  o.type = type;
  o.frequency.setValueAtTime(freq, s);
  if (endFreq) o.frequency.exponentialRampToValueAtTime(endFreq, s + dur);
  g.gain.setValueAtTime(0.0001, s);
  g.gain.exponentialRampToValueAtTime(gain, s + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, s + dur);
  o.connect(g).connect(c.destination);
  o.start(s); o.stop(s + dur + 0.02);
}

export const SFX = {
  chips: () => [0, 0.045, 0.085].forEach((t, i) => click(t, 3200 + i * 500, 0.9)),
  knock: () => { [0, 0.13].forEach((t) => { tone(t, 140, 0.09, 0.5, "triangle", 70); click(t, 900, 0.5, 0.03); }); },
  fold: () => click(0, 1800, 0.35, 0.18),
  deal: () => [0, 0.07, 0.14].forEach((t) => click(t, 2400, 0.4, 0.06)),
  turn: () => { tone(0, 880, 0.12, 0.18, "square"); tone(0.18, 880, 0.12, 0.18, "square"); },
  win: () => [0, 0.06, 0.12, 0.18, 0.24, 0.3].forEach((t, i) => click(t, 2800 + (i % 3) * 600, 0.8)),
  allIn: () => { SFX.chips(); tone(0.05, 220, 0.35, 0.15, "sawtooth", 440); },
};

export const unlockAudio = unlockFromGesture;

export const resumeAudio = () => { if (ctx && ctx.state !== "running") ctx.resume().catch(() => {}); };
